import React from 'react';
import {Header} from "../common";
import CenterContentBox from "../Champions/ContentWrapper";
import SummonerSearchTable from "./SummonerSearchTable";
import UseSetCanonical from "../../common/hooks/useSetCanonical";
import BottomStickAd from "../ad/BottomStickAd";
import useTitleAndDescription from "../../common/hooks/useTitleAndDescription";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";


const SummonerSearch = () => {
    const { summonerName} = useParams();
    const {t} = useTranslation()
    UseSetCanonical();
    useTitleAndDescription({
        title: t('header.titleSearch',{summoner:summonerName}),
        description: t('header.titleSearchDescription',{
            summoner: summonerName
        })
    })
    return (
        <div>
            <Header/>
            <CenterContentBox disableSponsor={true}>
                <SummonerSearchTable/>
            </CenterContentBox>
            <BottomStickAd/>
        </div>
    );
};

export default SummonerSearch;